

define(['components/json2/json2', 'components/es5-shim/es5-shim', 'components/es5-shim/es5-sham', 'components/EventShim/eventShim' /* ,
                                                                                                                                   './selectors' */

], function () {

    /*
     function isNative(fn) {
        return (/\{\s*\[native code\]\s*\}/).test('' + fn);
    }
     function patch(fn, emptyVal) {
         if (isNative(fn)) {
            return fn;
        }
         emptyVal = arguments.length === 2 ? emptyVal : null;
         return function() {
             if (!fn) {
                return emptyVal;
            }
             var result = fn.apply(this, arguments);
             if (result && (result.length === 1 && result[0] === null) || result.length === 0) {
                return emptyVal;
            }
             return result;
        }
    }
     document.querySelector          = patch(document.querySelector);
    document.querySelectorAll       = patch(document.querySelectorAll, []);
    Element.prototype.querySelector = patch(Element.prototype.querySelector);
     */
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-shims/dist/index.js
 ** module id = 92
 ** module chunks = 0
 **/